import { useTranslation } from "react-i18next"
import Div from '@ui/layout/Div'
import { useEffect, useState } from "react"
import { get } from '@util/xhrAPI'
import CompanySterilizationCallBuildings from "@scene/window/sterilization/__partials/CompanySterilizationCallBuildings"
import CompanySterilizationCallForm from "@scene/window/sterilization/__partials//CompanySterilizationCallForm"
import { useDispatch, useSelector } from "react-redux"
import { updateData } from '@store/slice/mainSlice'

const CompanySterilizationCallMaker = () => {
  const { mission, data } = useSelector(state => state.main)
  const dispatch = useDispatch()
  const [companyFormStep, setCompanyFormStep] = useState(!window.sessionStorage.getItem('lastCompanyCall') ? 'callInfos' : 'buildings')
  const [t] = useTranslation('sterilization')

  useEffect(() => {
    if ('buildings' === companyFormStep) {
      get(`${import.meta.env.VITE_API_URL}/missions/${mission.id}/mission-billings`, response => {
        const { code, missionBillings } = response
        if (200 === code) {
          dispatch(updateData({ ...data, missionBillings: { ...missionBillings } }))
        }
      })
    }
  }, [companyFormStep])

  return (
    <Div cssCalss='sterilization-request-maker'>
      <h2 className="scene-title">{t('titles.company_sterilization_call_maker')}</h2>
      {'callInfos' === companyFormStep
        ? <CompanySterilizationCallForm nextStep={setCompanyFormStep} />
        : <CompanySterilizationCallBuildings />
      }
    </Div>
  )
}

export default CompanySterilizationCallMaker